/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Overview_TitleInputs */

const he_dashboard_overview_title = /** @type {(inputs: Dashboard_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סקירה כללית`)
};

const en_dashboard_overview_title = /** @type {(inputs: Dashboard_Overview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {Dashboard_Overview_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_overview_title = /** @type {((inputs?: Dashboard_Overview_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Overview_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_dashboard_overview_title(inputs)
	return en_dashboard_overview_title(inputs)
});